import { type IdOrIdentifier, idOrIdentifierSchema } from "~/tools/id-or-identifier";

import { purry } from "./_purry";
import { unpurry } from "./_unpurry";

export interface Identifiable {
	id: number;
	identifier: string;
}

function matchIdentifiableImplementation(identifiable: Identifiable, idOrIdentifier: IdOrIdentifier): boolean {
	const parsedIdOrIdentifierSchema = idOrIdentifierSchema.parse(idOrIdentifier);

	return identifiable.identifier === parsedIdOrIdentifierSchema || identifiable.id === parsedIdOrIdentifierSchema;
}

// data-first
function matchIdentifiablePurry(identifiable: Identifiable, idOrIdentifier: IdOrIdentifier): boolean;

// data-last
function matchIdentifiablePurry(idOrIdentifier: IdOrIdentifier): (identifiable: Identifiable) => boolean;

// curried
function matchIdentifiablePurry(...args: ReadonlyArray<unknown>): unknown {
	return purry(matchIdentifiableImplementation, args);
}

export const matchIdentifiable = unpurry(matchIdentifiablePurry, 2);
